module.exports = __webpack_public_path__ + "static/media/pharmacies-grey.0ff4a894.svg";